export interface DeleteArticleRequest {
    ArticleId: string;
}

const deleteArticle = function (request: DeleteArticleRequest): Promise<string> {
    const url = `/api/DeleteArticle/${request.ArticleId}`;
    
    const formData = new FormData();
    formData.append('id', request.ArticleId);

    const requestInit: RequestInit = {
        method: 'DELETE'
    };

    return fetch(url, requestInit).then(response => {
        if (!response.ok)
            return response.text().then(text => text);

        return null;
    }).catch(error => {
        return error;
    });
}

export default {
    DeleteArticle: deleteArticle
}